// Hook TanStack Query — identite Systeme C du user courant (GET /api/me).
// Le SPA s'en sert pour NE PAS AFFICHER un shell qu'il devra retirer. Ce n'est
// pas une autorisation : voir `resolveAccessGate` dans src/lib/resolveAccessGate.ts.
import { useQuery } from '@tanstack/react-query';
import { api } from '@gs/api-client';

export interface Me {
  userId: string;
  email: string;
  fullName: string;
  companyId: string;
  isCorporateAdmin: boolean;
  /**
   * ADR-076 D3 — `false` = acces zero (aucun role effectif nulle part) : le SPA
   * rend la coquille d'accueil au lieu du lanceur. OPTIONNEL a dessein : un
   * serveur deploye avant ce lot ne renvoie pas le champ, et son absence ne doit
   * PAS se lire comme « aucun acces » (voir resolveAccessGate).
   */
  hasAnyAccess?: boolean;
  /**
   * Qui administre quoi (2026-09-26) — le verdict de la Console UG, lu en base. Choisit les tuiles
   * d'administration (src/lib/administrationTiles.ts), n'autorise rien. OPTIONNEL pour la meme
   * raison que `hasAnyAccess` : son absence se lit « non mesure », jamais « n'administre rien ».
   */
  administration?: MeAdministration;
}

export type MeAdministration =
  | {
      mesure: true;
      acces: 'corporate' | 'uca' | 'delegated' | null;
      compagnies: { companyId: string; companyName: string }[];
    }
  | { mesure: false };

export function useMe(enabled: boolean) {
  return useQuery({
    queryKey: ['hub', 'me'],
    queryFn: () => api.get<Me>('/api/me'),
    enabled,
    // Un refus d'acces est un ETAT stable, pas une erreur transitoire : zero
    // retry automatique. L'ecran unverifiable propose un refetch MANUEL
    // (createGsQueryClient ne retry deja pas les 401/403 — ceinture locale).
    retry: false,
  });
}
